export const NAV_ANIMATION_DURATION = 300;
